import singleSided from '@images/printables/single-sided.png'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { eq } from 'ember-truth-helpers'
import { t, type IntlService } from 'ember-intl'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import type { BookNote } from 'teacher-ui-client/services/contentful-client'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    bookNote: BookNote
    bookCode: string
    role: string
    themeKey?: ThemeKeys
  }
}

export class ResourcesBookNote extends Component<Signature> {
  @service intl!: IntlService

  get bookNoteViewModel() {
    const pdfType = 'blackAndWhitePdf'
    return {
      title: this.args.bookNote.fields?.title,
      fileName: this.args.bookNote.fields?.file?.fileName,
      pdfType,
      pdfTypeFormatted: this.intl.t(`bookLibrary.resources.mediaTypes.${pdfType}`),
      url: this.args.bookNote.fields?.file?.url,
    }
  }

  <template>
    <a
      href={{this.bookNoteViewModel.url}}
      download={{this.bookNoteViewModel.fileName}}
      target="_blank"
      rel="noreferrer noopener"
      class="border-dusty-black-100 text-dusty-black-300 flex w-28 flex-col rounded border-2 p-2 pb-3 shadow-md
        {{if (eq @themeKey 'blue') 'hover:border-oceany-blue-350'}}
        {{if (eq @themeKey 'green') 'hover:border-ms-green-350'}}
        {{if (eq @themeKey 'default') 'hover:border-dusty-black-300'}}
        "
      ...attributes
      {{pdfDownloadEvent
        category="Teacher Library - Book Notes"
        label=this.bookNoteViewModel.title
        file=this.bookNoteViewModel.fileName
        bookCode=@bookCode
        role=@role
        pdfType=this.bookNoteViewModel.pdfType
      }}
    >
      <div class="text-center text-xs">{{t "printables.pdf"}}</div>
      <div class="text-center text-xs">
        {{t "bookLibrary.resources.bookNotes"}}
      </div>
      <div class="mb-1 text-center text-xs">
        {{this.bookNoteViewModel.pdfTypeFormatted}}
      </div>
      <img
        src={{singleSided}}
        alt="{{t 'bookLibrary.resources.bookNotes'}} {{this.bookNoteViewModel.fileName}}"
        class="mx-auto mt-auto w-1/3"
      />
    </a>
  </template>
}
